import { createDefaultHeaders } from 'owa-service/lib/createDefaultHeader';
import { getUserCulture } from 'owa-session-store';
import { userDate } from 'owa-datetime/lib';

/**
 * Helper function to create 3S Query request headers
 */
export function createSubstrateSearchQueryHeaders(
    searchSessionId: string,
    customHeaders: { [key: string]: string }
) {
    const headers = createDefaultHeaders();

    // Add custom headers.
    headers['client-session-id'] = searchSessionId;
    headers['x-client-localtime'] = userDate().toString();
    headers['X-Search-Griffin-Version'] = 'GWSv2';
    headers['Accept-Language'] = getUserCulture();

    if (customHeaders) {
        Object.keys(customHeaders).forEach(k => {
            headers[k] = customHeaders[k];
        });
    }

    return headers;
}
